import React from 'react';
import styled, { css } from 'styled-components';
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const buttonStyles = css`
    width: ${({ width }) => (width ? width : null)};
    height: ${({ height }) => (height ? height : null)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: ${({ border }) => (border ? border : 'none')};
    padding: ${({ size }) => {
        if (size === 'xxxs') return '4px 10px';
        if (size === 'xxs') return '7px 12px';
        if (size === 'xs') return '10px 16px';
        if (size === 's') return '13px 20px';
        if (size === 'm') return '16px 24px';
        if (size === 'l') return '19px 32px';
        return 0;
    }};
    font-family: inherit;
    text-decoration: none;
    background: none;
    cursor: pointer;
    z-index: 1;
    margin: ${(props)=> props.$margin ? props.$margin : 0};
    background-color: ${({ $backgroundColor }) => ($backgroundColor ?? '#000000')};

    &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.05);
        background-color: ${({ $onHoverBackgroundColor }) => ($onHoverBackgroundColor ?? '#005587')};
        color: ${({ $onHoverColor }) => ($onHoverColor ?? '#FFFFFF')};
    }
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    color: ${({ $color }) => ($color ?? '#FFFFFF')};
    border-radius: 10rem;

    svg {
        path {
            fill: #FFFFFF;
        }
    }

    &:focus,
    &:focus-visible {
        /* box-shadow: 0 0 0 3px #A0DCFF; */
        /* outline: none; */
    }

    &:disabled {
        color: #53565A;
        background-color: #D0D0CE;
        cursor: default;

        svg {
            path {
                fill: #53565A;
            }
        }
    }
`;
//#endregion
export const StyledButton = styled.button`
    ${buttonStyles}
`;

export const Button = (props) => {
    const { children, variant, size, onClick, $color, $backgroundColor, $margin, ...rest } = props;
    return (
        <StyledButton variant={variant} size={size} onClick={onClick} $color={$color} $backgroundColor={$backgroundColor} $margin={$margin} {...rest}>
            {children}
        </StyledButton>
    );
};

export default Button;